import React from 'react';

import { Box } from '@material-ui/core';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { Link } from 'react-router-dom';

export const ImageItem = React.memo(({
  src,
  onClick,
  alt,
  classes,
  classNames,
}) => {
  const imageElement = (
    <Box
      className={clsx(classes.img, {
        [classNames?.img]: classNames?.img,
      })}
      component="img"
      src={src}
      alt={alt}
    />
  );

  return onClick ? (
    <Link to={onClick} target="_blank">
      {imageElement}
    </Link>
  ) : imageElement;
});

ImageItem.propTypes = {
  src: PropTypes.string.isRequired,
  onClick: PropTypes.string,
  alt: PropTypes.string,
  classes: PropTypes.shape({
    img: PropTypes.string,
  }).isRequired,
  classNames: PropTypes.shape({
    img: PropTypes.string,
  }),
};

ImageItem.defaultProps = {
  onClick: null,
  alt: '',
  classNames: {},
};
